import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'
import { refreshToken, tokenExpiry, isTokenExpired, getTokenExpiry, withActiveToken } from '../lib/auth'
import { getAPIURL, getCachedBusiness, setCachedBusiness } from '../lib/utils'
import Loading from '../components/ui/loading'
import LandingPage from '../components/layout/landing-page'

const Landing = () => {
    const router = useRouter()
    const [tokenExpiryDate, setTokenExpiryDate] = useState(null);
    const cachedBusiness = getCachedBusiness();


    const fetchBusinessList = () => {

        return withActiveToken(() => {
            fetch(getAPIURL("businesses/"), {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        const activeBusiness = json[0];
                        router.push(`/${activeBusiness.uuid}/dashboard`);
                        setCachedBusiness(activeBusiness);

                        return;
                    });
                }
                return res.json().then((json) => Promise.reject(json));
            });
        }, router);
    }

    useEffect(() => {
        const handleAuth = async () => {
            try {
                await refreshToken();
                setTokenExpiryDate(getTokenExpiry());

                if (!isTokenExpired(getTokenExpiry()) && cachedBusiness) {
                    router.push(`/${cachedBusiness}/dashboard`);
                } else if (!isTokenExpired(getTokenExpiry()) && !cachedBusiness) {
                    await fetchBusinessList();
                }
            } catch (error) {
                setTokenExpiryDate(new Date(Date.now() - 60000)); // Set to 1 minute from now
            }
        };

        handleAuth();

    }, [router, cachedBusiness]);


    if (tokenExpiryDate === null) return <Loading />
    if (isTokenExpired(tokenExpiryDate)) {
        return (
            <LandingPage />
        )
    }
    return null
}
Landing.isUnprotected = true;
export default Landing